import { useMemo } from 'react';
import {
  APPOINTMENTS_LIST_URL,
  SCHEDULE_APPOINTMENT_CANCEL_URL,
  SCHEDULE_APPOINTMENT_URL,
} from '../../constants/constants';
import { handleRequestError, useRestClient } from './useRestClient';
import { AppointmentDTO } from '../DTOs/AppointmentDTO';
import { ScheduleDTO } from '../DTOs/schedule/ScheduleDTO';

export function useAppointmentsService() {
  const { restClient } = useRestClient();

  const getAppointmentsCardList = async (
    mine?: boolean
  ): Promise<AppointmentDTO[]> => {
    try {
      let url = `${APPOINTMENTS_LIST_URL}`;
      if (mine !== undefined) {
        url += `?mine=${mine}`;
      }

      const response = await restClient.get(url);

      return response.data;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  const getAppointmentDetails = async (
    appointmentId: string
  ): Promise<AppointmentDTO> => {
    try {
      const response = await restClient.get(
        `${APPOINTMENTS_LIST_URL}/${appointmentId}`
      );
      return response.data;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  const scheduleAppointment = async (scheduleDTO: ScheduleDTO) => {
    try {
      const { data } = await restClient.post(SCHEDULE_APPOINTMENT_URL, {
        ...scheduleDTO,
      });
      return data.message;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  const rescheduleAppointment = async (scheduleDTO: ScheduleDTO) => {
    try {
      const url = `${SCHEDULE_APPOINTMENT_URL}/${scheduleDTO.id}`;
      //debugger;
      delete scheduleDTO.id;
      const { data } = await restClient.put(url, {
        ...scheduleDTO,
      });
      return data.message;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  const cancelAppointment = async (appointmentId: string) => {
    try {
      const { data } = await restClient.put(
        `${SCHEDULE_APPOINTMENT_CANCEL_URL}/${appointmentId}`
      );
      return data.message;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  return useMemo(
    () => ({
      getAppointmentsCardList,
      getAppointmentDetails,
      scheduleAppointment,
      rescheduleAppointment,
      cancelAppointment,
    }),
    []
  );
}
